import { render, staticRenderFns } from "./ListComponent.vue?vue&type=template&id=6a9bd2d4&"
import script from "./ListComponent.vue?vue&type=script&lang=js&"
export * from "./ListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports